import {
  businessOrderStatistics,
  adviceOrderStatistics,
  complaintOrderStatistics,
  businessOrderPercent,
  businessOrderTop5,
  businessOrderTrend,
  payOrderStatistics
} from '@/apis/serviceOrder/workbench'
export default {
  data() {
    return {}
  },
  mounted() {},
  methods: {
    getAllData() {
      let params = this.params
      // 业务工单概况
      this.getWorkOrder()
      // 咨询工单概况
      adviceOrderStatistics(params).then(res => {
        if (res.code == 200) {
          let arr = [
            {
              name: '未解决',
              value: res.data.unSolveCount
            },
            {
              name: '已解决',
              value: res.data.solveCount
            }
          ]
          this.getzxOrderOverview(arr, res.data.solvePercent)
        }
      })
      // 投诉工单概况
      complaintOrderStatistics(params).then(res => {
        if (res.code == 200) {
          let arr = [
            {
              name: '未解决',
              value: res.data.unSolveCount
            },
            {
              name: '已解决',
              value: res.data.solveCount
            }
          ]
          this.gettsOrderOverview(arr, res.data.solvePercent)
        }
      })
      // 工单类型占比
      businessOrderPercent(params).then(res => {
        if (res.code == 200) {
          let arr = [
            {
              orderTypeName: '报修',
              num: res.data.bxcount
            },
            {
              orderTypeName: '安检',
              num: res.data.ajcount
            },
            {
              orderTypeName: '开通',
              num: res.data.ktcount
            },
            {
              orderTypeName: '巡检',
              num: res.data.xjcount
            }
          ]
          this.getorderProp(arr)
        }
      })
      // 收费情况
      payOrderStatistics(params).then(res => {
        if (res.code == 200) {
          this.getfeeSituation(res.data)
        }
      })
      // 维修员工单执行情况（top5）
      businessOrderTop5(params).then(res => {
        if (res.code == 200) {
          this.getOrderTask(res.data)
        }
      })
      // 工单趋势
      businessOrderTrend(params).then(res => {
        if (res.code == 200) {
          let trans = {
            legend: ['报修', '开通', '安检', '巡检'],
            xAxis: res.data.timeAxis,
            series: [
              {
                data: res.data.bxaxis,
                name: '报修',
                type: 'line'
              },
              {
                data: res.data.ktaxis,
                name: '开通',
                type: 'line'
              },
              {
                data: res.data.ajaxis,
                name: '安检',
                type: 'line'
              },
              {
                data: res.data.xjaxis,
                name: '巡检',
                type: 'line'
              }
            ]
          }
          this.getorderTrend(trans)
        }
      })
      // this.getorderTrend()
    },
    // 业务工单概况
    getWorkOrder() {
      businessOrderStatistics(this.params).then(res => {
        if (res.code == 200) {
          this.workOrder = res.data
        }
      })
    },
    // 咨询工单概况
    getzxOrderOverview(seriesData, rateNum) {
      // var seriesData = [
      //   {
      //     name: '未解决',
      //     value: 4544
      //   },
      //   {
      //     name: '已解决',
      //     value: 3321
      //   }
      // ]
      var optionColorArr = {
        已解决: '#718AFF',
        未解决: '#D9E0FF'
      }
      let option = {
        color: seriesData.map(item => optionColorArr[item.name]),
        title: {
          text: `{a| 解决率 }`,
          textStyle: {
            rich: {
              a: {
                fontSize: '15px',
                color: '#686C87'
              }
            },
            align: 'center'
          },
          subtext: `{a|${rateNum}}`,
          subtextStyle: {
            rich: {
              a: {
                fontSize: 26,
                color: '#000',
                padding: [0, 0, 0, -20],
                fontWeight: 'bold'
              }
            },
            align: 'center'
          },
          x: '20%',
          y: '32%'
        },
        tooltip: {
          trigger: 'item',
          show: false
        },
        grid: {
          top: '0',
          left: '0',
          right: '0',
          bottom: '0',
          containLabel: true
        },
        legend: {
          type: 'scroll',
          orient: 'vertical',
          left: '60%',
          top: 'middle',
          itemHeight: 10,
          itemWidth: 10,
          itemGap: 20,
          height: 300,
          icon: 'circle',
          formatter: function(name) {
            for (var i = 0; i < seriesData.length; i++) {
              if (name == seriesData[i].name) {
                return `{a| ${name}\n}{b0| ${seriesData[i].value}}`
              }
            }
          },
          textStyle: {
            height: 10,
            rich: {
              a: {
                color: '#686C87',
                fontSize: '15px'
              },
              b0: {
                // color: colorList[0],
                color: '#686C87',
                fontSize: '15px',
                fontWeight: 800,
                padding: [10, 0, 0, 0]
              }
            }
          }
        },
        series: [
          {
            type: 'pie',
            center: ['30%', '50%'],
            radius: ['60%', '80%'],
            clockwise: true, //饼图的扇区是否是顺时针排布
            avoidLabelOverlap: false,
            label: {
              normal: {
                show: false
              }
            },
            data: seriesData
          }
        ]
      }
      this.zxOrderOverview.setOption(option, true)
    },
    // 投诉工单概况
    gettsOrderOverview(seriesData, rateNum) {
      // var seriesData = [
      //   {
      //     name: '未解决',
      //     value: 4544,
      //     rate: 50
      //   },
      //   {
      //     name: '已解决',
      //     value: 3321,
      //     rate: 40
      //   }
      // ]
      var optionColorArr = {
        已解决: '#FCBC0D',
        未解决: '#FFEFC2'
      }
      let option = {
        color: seriesData.map(item => optionColorArr[item.name]),
        title: {
          text: `{a| 解决率 }`,
          textStyle: {
            rich: {
              a: {
                fontSize: 15,
                color: '#686C87'
              }
            },
            align: 'center'
          },
          subtext: `{a|${rateNum}}`,
          subtextStyle: {
            rich: {
              a: {
                fontSize: 26,
                color: '#000',
                padding: [0, 0, 0, -20],
                fontWeight: 'bold'
              }
            },
            align: 'center'
          },
          x: '20%',
          y: '32%'
        },
        tooltip: {
          trigger: 'item',
          show: false
        },
        grid: {
          top: '0',
          left: '0',
          right: '0',
          bottom: '0',
          containLabel: true
        },
        legend: {
          type: 'scroll',
          orient: 'vertical',
          left: '60%',
          top: 'middle',
          itemHeight: 10,
          itemWidth: 10,
          itemGap: 20,
          height: 300,
          icon: 'circle',
          formatter: function(name) {
            for (var i = 0; i < seriesData.length; i++) {
              if (name == seriesData[i].name) {
                return `{a| ${name}\n}{b0| ${seriesData[i].value}}`
              }
            }
          },
          textStyle: {
            height: 10,
            rich: {
              a: {
                color: '#686C87',
                fontSize: '15px'
              },
              b0: {
                // color: colorList[0],
                color: '#686C87',
                fontSize: '15px',
                fontWeight: 800,
                padding: [10, 0, 0, 0]
              }
            }
          }
        },
        series: [
          {
            type: 'pie',
            center: ['30%', '50%'],
            radius: ['60%', '80%'],
            clockwise: true, //饼图的扇区是否是顺时针排布
            avoidLabelOverlap: false,
            label: {
              normal: {
                show: false
              }
            },
            data: seriesData
          }
        ]
      }
      this.tsOrderOverview.setOption(option, true)
    },
    // 维修员工单执行情况（top5）
    getOrderTask(trans) {
      // let trans = [
      //   {
      //     realname: '赵铂龙',
      //     count: 17
      //   },
      //   {
      //     realname: '张巍',
      //     count: 8
      //   },
      //   {
      //     realname: '蒋昭旭',
      //     count: 7
      //   },
      //   {
      //     realname: '李超',
      //     count: 6
      //   },
      //   {
      //     realname: '李依伦',
      //     count: 4
      //   }
      // ]
      let [xData, yData] = [[], []]
      if (trans.length) {
        trans.forEach(e => {
          xData.push(e.realname)
          yData.push(e.count)
        })
      }
      let xdata = {
        value: xData
      }
      let sdata = {
        value: yData
      }

      let option = {
        tooltip: {
          trigger: 'axis'
        },
        grid: {
          containLabel: true,
          bottom: '5%',
          left: '5%',
          top: '0',
          right: '5%'
        },
        xAxis: {
          type: 'value',
          axisLabel: {
            show: false
          },
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          splitLine: {
            show: false
          }
        },
        yAxis: [
          {
            type: 'category',
            data: xdata.value,
            inverse: true,
            axisLabel: {
              fontSize: '15px',
              inside: false,
              verticalAlign: 'center',
              padding: [5, 0, 0, 0],
              margin: 20 //刻度标签与轴线之间的距离
            },
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            splitLine: {
              show: false,
              lineStyle: {
                color: '#13387a'
              }
            }
          },

          {
            type: 'category',
            data: xdata.value,
            inverse: true,
            axisLabel: {
              inside: false,
              verticalAlign: 'center',
              padding: [5, 0, 0, 0],
              margin: 20, //刻度标签与轴线之间的距离
              formatter: function(value, index) {
                return `{a|${sdata.value[index]}}`
              },
              rich: {
                a: {
                  fontSize: 16,
                  fontFamily: 'Barlow Condensed SemiBold',
                  color: '#333',
                  padding: [4, 0, 0, 0]
                }
              }
            },
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            splitLine: {
              show: false,
              lineStyle: {
                color: '#13387a'
              }
            }
          }
        ],
        series: [
          {
            data: sdata.value,
            type: 'bar',
            barWidth: 20,
            showBackground: true,
            backgroundStyle: {
              color: '#F5F5F5'
            },
            itemStyle: {
              color: '#4874CB'
            }
          }
        ]
      }

      this.orderTask.setOption(option, true)
    },
    // 工单类型占比
    getorderProp(trans) {
      // let trans = [
      //   {
      //     orderTypeName: '咨询',
      //     num: 7
      //   },
      //   {
      //     orderTypeName: '事件',
      //     num: 10
      //   },
      //   {
      //     orderTypeName: '表扬',
      //     num: 5
      //   },
      //   {
      //     orderTypeName: '安检',
      //     num: 3
      //   },
      //   {
      //     orderTypeName: '投诉',
      //     num: 8
      //   },
      //   {
      //     orderTypeName: '报修',
      //     num: 4
      //   },
      //   {
      //     orderTypeName: '报装',
      //     num: 4
      //   },
      //   {
      //     orderTypeName: '开通',
      //     num: 40
      //   }
      // ]
      let [xdata, ydata] = [[], []]
      if (trans.length) {
        trans.forEach(e => {
          xdata.push(e.orderTypeName)
          ydata.push({ name: e.orderTypeName, value: e.num })
        })
      }
      var color = [
        '#718AFF',
        '#56B3F6',
        '#5470C6',
        '#9E73FF',
        '#F7C12D',
        '#FC8452',
        '#FB504A',
        '#91CC75'
      ]
      let option = {
        backgroundColor: 'rgba(255,255,255,1)',
        color: color,
        legend: {
          // right: '2%',
          right: '10%',
          // bottom: '10%',
          bottom: '30%',
          data: xdata,
          itemWidth: 12,
          itemHeight: 12,
          // width: 300,
          width: 200,
          itemGap: 30,
          icon: 'circle',
          formatter: function(name) {
            var oa = option.series[0].data
            for (var i = 0; i < option.series[0].data.length; i++) {
              if (name == oa[i].name) {
                return `{a| ${name} }{b0| ${oa[i].value}}`
              }
            }
          },
          textStyle: {
            rich: {
              a: {
                color: '#686C87',
                fontSize: '15px'
              },
              b0: {
                color: '#686C87',
                fontSize: '15px',
                fontWeight: 800
              }
            }
          }
        },
        series: [
          {
            type: 'pie',
            clockwise: false, // 饼图的扇区是否是顺时针排布
            minAngle: 2, // 最小的扇区角度（0 ~ 360）
            radius: ['66%', '90%'],
            // center: ['20%', '50%'],
            center: ['30%', '50%'],
            avoidLabelOverlap: false,
            itemStyle: {
              // 图形样式
              normal: {
                borderColor: '#ffffff',
                borderWidth: 3
              }
            },
            label: {
              normal: {
                show: false,
                position: 'center',
                formatter: '{text|{b}}\n{c} ',
                rich: {
                  text: {
                    color: '#666',
                    fontSize: 12,
                    align: 'center',
                    verticalAlign: 'middle',
                    padding: 8
                  },
                  value: {
                    color: '#8693F3',
                    fontSize: 16,
                    align: 'center',
                    verticalAlign: 'middle'
                  }
                }
              },
              emphasis: {
                show: true,
                textStyle: {
                  fontSize: 20
                }
              }
            },
            data: ydata
          }
        ]
      }
      this.orderProp.setOption(option, true)
    },
    getfeeSituation(data) {
      var seriesData = [
        {
          name: '线上',
          value: data.onLine
        },
        {
          name: '线下',
          value: data.outLine
        }
      ]
      var optionColorArr = {
        线上: '#91CC75',
        线下: '#5470C6'
      }

      let allNum = (seriesData[0]['value'] + seriesData[1]['value']).toFixed(2)
      let option = {
        color: seriesData.map(item => optionColorArr[item.name]),
        title: {
          text: `{a| 合计 }`,
          textStyle: {
            rich: {
              a: {
                fontSize: 15,
                color: '#686C87'
              }
            },
            align: 'center'
          },
          subtext: `{a|${allNum}元}`,
          subtextStyle: {
            rich: {
              a: {
                fontSize: 26,
                color: '#000',
                fontWeight: 'bold'
              }
            },
            align: 'center'
          },
          x: '55%',
          y: '10%'
        },
        tooltip: {
          trigger: 'item',
          show: false
        },
        grid: {
          top: '0',
          left: '0',
          right: '0',
          bottom: '0',
          containLabel: true
        },
        legend: {
          type: 'scroll',
          orient: 'vertical',
          left: '55%',
          bottom: '10%',
          itemHeight: 10,
          itemWidth: 10,
          itemGap: 20,
          height: 300,
          icon: 'circle',
          formatter: function(name) {
            for (var i = 0; i < seriesData.length; i++) {
              if (name == seriesData[i].name) {
                return `{a| ${name}}{b0| ${seriesData[i].value}元}`
              }
            }
          },
          textStyle: {
            rich: {
              a: {
                color: '#8D8D8D',
                fontSize: 14
              },
              b0: {
                // color: colorList[0],
                color: '#333',
                fontSize: 14,
                fontWeight: 800
              }
            }
          }
        },
        series: [
          {
            type: 'pie',
            center: ['30%', '50%'],
            radius: ['60%', '80%'],
            clockwise: true, //饼图的扇区是否是顺时针排布
            avoidLabelOverlap: false,
            label: {
              normal: {
                show: false
              }
            },
            data: seriesData
          }
        ]
      }
      this.feeSituation.setOption(option, true)
    },
    // 工单趋势
    getorderTrend(trans) {
      // let trans = {
      //   legend: [
      //     '报修',
      //     '开通',
      //     '安检',
      //     '巡检'
      //   ],
      //   xAxis: ['2024.07.23', '2024.07.24', '2024.07.25', '2024.07.26', '2024.07.29', '2024.07.30'],
      //   series: [
      //     {
      //       data: [93, 224, 109, 107, 80, 6],
      //       name: '报修',
      //       type: 'line'
      //     },
      //     {
      //       data: [3, 12, 7, 0, 5, 0],
      //       name: '开通',
      //       // symbol: 'none',
      //       type: 'line'
      //     },
      //     {
      //       data: [0, 0, 0, 0, 0, 0],
      //       name: '安检',
      //       type: 'line'
      //     },
      //     {
      //       data: [2, 2, 3, 2, 1, 0],
      //       name: '巡检',
      //       type: 'line'
      //     },
      //   ]
      // }
      let option = {
        color: ['#FC5136', '#FCC136', '#26B881', '#36A6FC', '#FC8C36', '#6F78CF'],
        tooltip: {
          trigger: 'axis'
        },
        // dataZoom: [
        //   {
        //     type: 'slider',
        //     start: 70,
        //     end: 100
        //   }
        // ],
        legend: {
          data: trans.legend,
          right: 'center',
          itemGap: 15,
          itemWidth: 15,
          width: 800,
          textStyle: {
            fontSize: '15px',
            color: '#686C87',
            align: 'center'
          },
          itemStyle: { opacity: 0 }
        },
        grid: {
          left: '50',
          right: '50',
          bottom: '20px',
          containLabel: true
        },
        // toolbox: {
        //   feature: {
        //     saveAsImage: {}
        //   }
        // },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: trans.xAxis
        },
        yAxis: {
          type: 'value'
        },
        series: trans.series
      }
      this.orderTrend.setOption(option, true)
    }
  }
}
